module.exports = __webpack_public_path__ + "static/assets/129f7ee19a8eeac3a8aff8bb27b0ecc0.svg";